module.exports = __webpack_public_path__ + "img/safeConfig.72ffe887.svg";